import { getTelLinkFromPhone } from "./utils/getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "./utils/getWhatsappLinkFromPhone";
import { formatToURL } from "./utils/formatToURL";

export function getMenu(component) {
  return [
    {
      text: "Início",
      to: "/",
    },
    {
      text: "Sobre Nós",
      to: "/sobre-nos",
    },
    {
      text: "Serviços",
      to: "/",
      submenu: component.services.map(({ id, title }) => ({
        text: title,
        to: `/servicos/${formatToURL(title)}-${id}`,
      })),
    },
    // {
    //   text: "Social",
    //   to: "/",
    //   submenu: component.social.map(({ id, title }) => ({
    //     text: title,
    //     to: `/social/${formatToURL(title)}-${id}`,
    //   })),
    // },
    {
      text: "Projetos Sociais",
      to: "/",
      submenu: [
        ...[
          {
            text: "Espaço Cultural",
            to: "/projetos/espaco-cultural",
          },
        ],
        ...component.projects.map(({ id, title }) => ({
          text: title,
          to: `/projetos/${formatToURL(title)}-${id}`,
        })),
        ...[
          {
            text: "Nasci no Dois Pinheiros",
            to: "/projetos/nasci-no-h2p",
          },
        ],
      ],
    },
    {
      text: "Atendimento",
      to: "/atendimento",
    },
    {
      text: "Imprensa",
      to: "/",
      submenu: [
        {
          text: "Fotos e Eventos",
          to: "/imprensa/galerias-de-fotos",
        },
        {
          text: "Notícias e Releases",
          to: "/imprensa/noticias",
        },
        {
          text: "Vídeos",
          to: "/imprensa/videos",
        },
        {
          text: "Boletim Médico",
          to: "/imprensa/boletim-medico",
        },
        {
          text: "Contato para Imprensa",
          to: "/imprensa/contato-para-imprensa",
        },
      ],
    },
  ];
}

export function getSocial(item) {
  const social = [];

  if (item.facebook)
    social.push({
      title: "Facebook",
      link: item.facebook,
      icon: "fab fa-facebook-f",
      size: 20,
    });
  if (item.instagram)
    social.push({
      title: "Instagram",
      link: item.instagram,
      icon: "fab fa-instagram",
      size: 22,
    });
  if (item.youtube)
    social.push({
      title: "Youtube",
      link: item.youtube,
      icon: "fab fa-youtube",
      size: 20,
    });
  if (item.twitter)
    social.push({
      title: "Twitter",
      link: item.twitter,
      icon: "fab fa-twitter",
      size: 20,
    });
  if (item.linkedin)
    social.push({
      title: "Linkedin",
      link: item.linkedin,
      icon: "fab fa-linkedin",
      size: 20,
    });

  return social;
}

export function getContact(component) {
  const contact = [];

  if (component.contacts.tel) {
    let telSplit = component.contacts.tel.split(";");

    if (Array.isArray(telSplit)) {
      let tel = [];
      telSplit.forEach(function (val) {
        tel.push({
          title: val,
          colorTitle: "white--text",
          sizeTitle: "text-h6 text-md-h5",
          link: getTelLinkFromPhone(val),
          target: "_self",
          icon: "fa-phone-alt",
          size: 16,
        });
      });

      contact.push(tel);
    } else {
      contact.push({
        title: component.contacts.tel,
        colorTitle: "white--text",
        sizeTitle: "text-h6 text-md-h5",
        link: getTelLinkFromPhone(component.contacts.tel),
        target: "_self",
        icon: "fa-phone-alt",
        size: 16,
      });
    }
  }

  if (component.contacts.whatsapp) {
    let whatsappSplit = component.contacts.whatsapp.split(";");

    if (Array.isArray(whatsappSplit)) {
      let whatsapp = [];
      whatsappSplit.forEach(function (val) {
        whatsapp.push({
          title: val,
          colorTitle: "white--text",
          sizeTitle: "text-h6 text-md-h5",
          link: getWhatsappLinkFromPhone(val),
          target: "_blank",
          icon: "fa-whatsapp",
          size: 20,
        });
      });

      contact.push(whatsapp);
    } else {
      contact.push({
        title: component.contacts.whatsapp,
        colorTitle: "white--text",
        sizeTitle: "text-h6 text-md-h5",
        link: getWhatsappLinkFromPhone(component.contacts.whatsapp),
        target: "_blank",
        icon: "fa-whatsapp",
        size: 20,
      });
    }
  }

  if (component.contacts.email) {
    let emailSplit = component.contacts.email.split(";");

    if (Array.isArray(emailSplit)) {
      let email = [];
      emailSplit.forEach(function (val) {
        email.push({
          title: val,
          colorTitle: "primary--text text--lighten-3",
          sizeTitle: "text-body-1 text-md-h6",
          link: "mailto:" + val,
          target: "_self",
          icon: "far fa-envelope",
          size: 18,
        });
      });

      contact.push(email);
    } else {
      contact.push({
        title: component.contacts.email,
        colorTitle: "primary--text text--lighten-3",
        sizeTitle: "text-body-1 text-md-h6",
        link: "mailto:" + component.contacts.email,
        target: "_self",
        icon: "far fa-envelope",
        size: 18,
      });
    }
  }

  if (component.contacts.address)
    contact.push({
      title: component.contacts.address,
      colorTitle: "primary--text text--lighten-3",
      sizeTitle: "text-body-1 text-md-h6",
      link: component.contacts.google_maps,
      target: "_blank",
      icon: "fa-map-marker-alt",
      size: 18,
    });

  return contact;
}
